import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

const BACKEND_URL = environment.apiUrl + "/orders/";

@Injectable({
  providedIn: "root"
})

export class OrdersService {

  constructor(
    private http: HttpClient,
  ) { }

  // [express]
  createExpressOrder(
    files: any[],
    printerID: string,
    printingCode: string = null,
    branchTranslatedName: string = null,
    ipToPrint: boolean = true,
    fixProductsOrderId: string = null,
    expressAttachedOrderId: string = null,
    picsDiscount: number = null,
  ): Observable<any> {
    const url = `${BACKEND_URL}createexpress`;
    const body = {
      files: files,
      printerID: printerID,
      printingCode: printingCode,
      branchTranslatedName: branchTranslatedName,
      ipToPrint: ipToPrint,
      fixProductsOrderId: fixProductsOrderId,
      expressAttachedOrderId: expressAttachedOrderId,
      picsDiscount: picsDiscount,
    };
    return this.http.post(url, body);
  }

  // [plotter]
  createPlotterOrder(
    files: any[],
    printerID: string,
    branchTranslatedName: string = null,
    ipToPrint: boolean = true,
  ): Observable<any> {
    const url = `${BACKEND_URL}createplotter`;
    const body = {
      files: files,
      printerID: printerID,
      branchTranslatedName: branchTranslatedName,
      ipToPrint: ipToPrint,
    };
    return this.http.post(url, body);
  }

  checkOrderStatus(
    service: string,
    orderId: string,
  ): Observable<any> {
    const url = `${BACKEND_URL}checkorderstatus/${service}/${orderId}`;
    return this.http.get(url).pipe(
      tap(response => console.log('Order status:', response))
    );
  }

  // [express] - fix products
  createFixProductsOrder(
    products: any[],
    printerID: string,
    branchTranslatedName: string = null,
  ): Observable<any> {
    const url = `${BACKEND_URL}createfixproducts`;
    const body = {
      products: products,
      printerID: printerID,
      branchTranslatedName: branchTranslatedName,
    };
    return this.http.post(url, body);
  }

  createEmptyFixProductsOrder(userId: string, totalCost: number): Observable<any> {
    const url = `${BACKEND_URL}createemptyfixproductsorder`;
    return this.http.post(url, { userId, totalCost });
  }

  payEmptyFixProductsOrder(fixProductsOrderId: string): Observable<any> {
    const url = `${BACKEND_URL}payemptyfixproductsorder`;
    return this.http.post(url, { fixProductsOrderId });
  }

  // [ph] 
  createPHOrder(
    files: any[],
    productName: string,
    userId: string,
    totalCost: number,
    collectionData: any = null,
    selectedPlace: any = null
  ): Observable<any> {
    const url = `${BACKEND_URL}createphorder`;
    const body = {
      files,
      productName,
      userId,
      totalCost,
      collectionData,
      selectedPlace
    };
    return this.http.post(url, body);
  }

}
